import { axiosBeelineRequest } from '@beef/utils';
import { AxiosResponse } from 'axios';

type BasketPayload = AxiosResponse<{
  constructorTariffData: {
    optionSocs: string;
    tariffConstructorId: number;
  };
  tariffId: number;
}>;

/** Получение basketPayload по выбранному тарифу (его soc) для дальнейшего формирования заказа в шопе */
export const fetchCatalogBasketInfo = (soc: string) =>
  axiosBeelineRequest<BasketPayload>({
    method: 'get',
    url: '/api/v1/constructors/catalog-basket-info',
    params: { soc },
  }).then((res) => res?.data);
